import { useContext } from 'react';
import { GlobalContext } from '../../../App';
import useGeneralQueries from './useGeneralQueries';
import { openDB } from 'idb';

const useCURD_Queries = () => {
  const { token, setToken, setLoading } = useContext(GlobalContext);
  const { AddItem2, AddItem, setAllItems, RemoveItem } = useGeneralQueries();


  // --------------------------

  // const dbPromise = openDB('myDatabase', 1, {
  //   upgrade(db) {
  //     db.createObjectStore('myStore', { keyPath: 'name' });
  //   },
  // });

  // ---------------------

  // פונקציה לקבלת ערכים
  const AllDataEntities = async (url) => {
    const maxRetries = 5; // מספר הפעמים להפעלת הפונקציה שניגשת לשרת
    let res = null; // הערך המוחזר מהשרת, או מערך ריק במקרה של תקלה

    setLoading(true); // מעדכן את האפליקציה שמתחילים טעינת נתונים

    // פונקציה שמבצעת בקשה לשרת ומחזירה את הערכים
    async function fetchData() {
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: token })
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        let resData = await response.json();

        // בדיקה אם resData הוא מערך
        if (!Array.isArray(resData)) {
          console.error('resData אינו מערך');
          resData = []; // טיפול במקרה בו לא מחזירים מערך
        }

        console.log('סיים טעינה');
        localStorage.setItem('connection', JSON.stringify({ active: false }));
        return { resData }; // החזרת הנתונים
      } catch (error) {
        console.error('שגיאה בבקשת הנתונים:', error);
        return null; // החזרת null במקרה של תקלה
      }
    }

    // פונקציה אסיכרונית המפעילה לולאה לקבלת ערכים מהשרת במקרה של תקלה
    async function retryLoop() {
      for (let index = maxRetries; index > 0; index--) {
        console.log(`ניסיון מספר ${maxRetries - index + 1}`);

        try {
          const data = await fetchData();

          if (data !== null) {
            localStorage.setItem('connection', JSON.stringify({ active: false }));
            return data; // יציאה מהלולאה במקרה של הצלחה
          }
        } catch (error) {
          console.error('שגיאה בניסיון החוזר:', error);
        }

        localStorage.setItem('connection', JSON.stringify({ msg: `תקלת התחברות, מנסה שוב בעוד ${index}`, active: true }));
        
        await new Promise((resolve) => setTimeout(resolve, 5000)); // המתנה של 5 שניות בין כל איטרציה
      }

      // אם לא הצלחנו לקבל נתונים לאחר מספר ניסיונות
      await new Promise((resolve) => setTimeout(resolve, 5000));

      localStorage.removeItem('token');
      localStorage.removeItem('connection');
      setToken(null);

      return null;
    }

    // ניסיון בקשה ראשונה ישירה
    res = await fetchData();

    // אם הבקשה הראשונית נכשלה, נכנסים ללולאה
    if (res === null) {
      res = await retryLoop();
    }

    setLoading(false);
    return res;
  };

  // הוספת נתון
  const addOrUpdateDataEntity = async (data, payload, url) => {
    try {
      const response = await AddItem(url, data, { token, payload });
      console.log('סיים טעינה', response); // הדפסה של התגובה מהשרת
      return response; // החזרת התגובה
    } catch (error) {
      console.error('שגיאה:', error);
      throw error; // העברת השגיאה לשלב הקודם
    }
  };
  
  // הוספת נתון
  const addOrUpdateDataEntity2 = async (data, payload, url) => {
      try {
        console.log('step4:',url, data, { token, payload });
        
        await AddItem2(url, data, { token, payload });
        console.log('סיים טעינה', data);
        return 200;
      } catch (error) {
        console.error('שגיאה: ', error);
        throw error; // כדי שהשגיאה תוכל להתפס ב-addOrUpdateDataCemetery
      }
  };

  const setAllData = async (data, url) => {
    // החזרת הפרומיס מ-AddItem
    try {
      await setAllItems(url, data, { token });
      console.log('סיים טעינה', data);
    } catch (error) {
      console.error('שגיאה: ', error);
      throw error; // כדי שהשגיאה תוכל להתפס ב-addOrUpdateDataCemetery
    }
  };

  // קבלת אב הנתון
  const getChildrensByFather = (id, data = [], father = '') => {
    if (data.length) {
      return data.filter((item) => item[father] === id);
    }
    return [];
  };

  // קבלת הרשומה עם האיידי
  const getEntityById = (id, data = []) => {
    return data.find((entity) => entity.id === id);
  };

  const NextAutoIncrementEntity = async (url) => {
    const maxRetries = 5; // מספר הפעמים להפעלת הפונקציה שניגשת לשרת
    let res = null; // הערך המוחזר מהשרת, או מערך ריק במקרה של תקלה

    setLoading(true); // מעדכן את האפליקציה שמתחילים טעינת נתונים

    // פונקציה שמבצעת בקשה לשרת ומחזירה את הערכים
    async function fetchData() {
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: token })
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        let resData = await response.json();

        // // בדיקה אם resData הוא מערך
        // if (!Array.isArray(resData)) {
        //   console.error('resData אינו מערך');
        //   resData = []; // טיפול במקרה בו לא מחזירים מערך
        // }

        console.log('סיים טעינה');
        // localStorage.setItem('connection', JSON.stringify({ active: false }));
        return { resData }; // החזרת הנתונים
      } catch (error) {
        console.error('שגיאה בבקשת הנתונים:', error);
        return null; // החזרת null במקרה של תקלה
      }
    }

    // פונקציה אסיכרונית המפעילה לולאה לקבלת ערכים מהשרת במקרה של תקלה
    async function retryLoop() {
      for (let index = maxRetries; index > 0; index--) {
        console.log(`ניסיון מספר ${maxRetries - index + 1}`);

        try {
          const data = await fetchData();

          if (data !== null) {
            localStorage.setItem('connection', JSON.stringify({ active: false }));
            return data; // יציאה מהלולאה במקרה של הצלחה
          }
        } catch (error) {
          console.error('שגיאה בניסיון החוזר:', error);
        }

        localStorage.setItem('connection', JSON.stringify({ msg: `תקלת התחברות, מנסה שוב בעוד ${index}`, active: true }));
        
        await new Promise((resolve) => setTimeout(resolve, 5000)); // המתנה של 5 שניות בין כל איטרציה
      }

      // אם לא הצלחנו לקבל נתונים לאחר מספר ניסיונות
      await new Promise((resolve) => setTimeout(resolve, 5000));

      localStorage.removeItem('token');
      localStorage.removeItem('connection');
      setToken(null);

      return null;
    }

    // ניסיון בקשה ראשונה ישירה
    res = await fetchData();

    // אם הבקשה הראשונית נכשלה, נכנסים ללולאה
    if (res === null) {
      res = await retryLoop();
    }

    setLoading(false);
    return res;

    // if (data?.id) {
    //   try {
    //     await RemoveItem(url, data, { token });
    //     return 200;
    //   } catch (error) {
    //     console.error('שגיאה: ', error);
    //     throw error; // כדי שהשגיאה תוכל להתפס ב-removeEntity
    //   }
    // }
  };

  // מחיקת נתון
  const removeEntity = async (data, url) => {
    if (data?.id) {
      try {
        await RemoveItem(url, data, { token });
        return 200;
      } catch (error) {
        console.error('שגיאה: ', error);
        throw error; // כדי שהשגיאה תוכל להתפס ב-removeEntity
      }
    }
  };

  return {
    AllDataEntities,
    NextAutoIncrementEntity,
    setAllData,
    addOrUpdateDataEntity,
    addOrUpdateDataEntity2,
    getChildrensByFather,
    getEntityById,
    removeEntity
  };
};

export default useCURD_Queries;



